// extracted by mini-css-extract-plugin
module.exports = {"text":"_7fe4949e52de76e30ed65faac9ecfe7c-less"};